<template>
  <div class="aside_snb">
    <!-- BASE MENU OPTIONS SHOWN IN LIBRARY -->
    <div v-if="$route.path.includes('library')" class="snb_menu">
      <div class="snb_box user_name book_sort">
        <span v-if="getCurrentUser" class="base_NM18">
          {{ getCurrentUser.memberNm }} 님
        </span>
      </div>
      <div
        :class="{ 'no-scroll': !needsScroll }"
        class="snb_box snb_box_scroll"
      >
        <!-- 고정 책장 (전체도서) -->
        <ul
          v-if="!isBookshelfLoading && staticBookshelves.length > 0"
          class="snb_sub"
        >
          <ListItem
            v-for="bookshelf in staticBookshelves"
            :key="bookshelf.id"
            :bookshelf="bookshelf"
            :isShelfMoveMode="isShelfMoveMode"
            @openEditModal="openEditModal(bookshelf)"
            @openDeleteModal="openDeleteModal(bookshelf)"
            @bookshelfChanged="onBookshelfChanged"
            @moveShelf="moveShelf"
            @fixShelf="fixShelf"
          />
        </ul>
        <draggable
          v-model="draggableBookshelves"
          tag="ul"
          :class="'snb_sub'"
          :disabled="!isShelfMoveMode"
          ghost-class="ghost-bookshelf"
          handle=".move_shelf"
          :fallbackClass="'drag-fallback'"
          :fallbackOnBody="true"
          :forceFallback="true"
        >
          <ListItem
            v-for="bookshelf in draggableBookshelves"
            :key="bookshelf.id"
            :bookshelf="bookshelf"
            :isShelfMoveMode="isShelfMoveMode"
            @openEditModal="openEditModal(bookshelf)"
            @openDeleteModal="openDeleteModal(bookshelf)"
            @bookshelfChanged="onBookshelfChanged"
          />
          <span></span>
        </draggable>
      </div>
      <div class="border"></div>
      <div class="snb_insert">
        <button type="button" class="btn_insert" @click="openNewModal">
          <span>책장 추가</span>
          <span class="svg_insert"></span>
        </button>
        <span class="info_ment">도서를 목적에 맞게 정리할 수 있어요!</span>
      </div>
    </div>

    <div v-if="!$route.path.includes('library')" class="snb_menu_area">
      <div v-if="getCurrentUser" class="snb_box user_name">
        <span class="base_NM18">{{ getCurrentUser.memberNm }} 님</span>
      </div>
      <div class="snb_menu">
        <div class="snb_box">
          <p class="snb_tit">{{ $t('library.sidebar.4997') }}</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'faq' }">
              <router-link :to="{ name: 'faq' }" class="snb_list">{{
                $t('common.footer.7188')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'events' }">
              <router-link :to="{ name: 'events' }" class="snb_list">{{
                $t('library.sidebar.3903')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'newsletters' }">
              <router-link :to="{ name: 'newsletters' }" class="snb_list">
                뉴스레터
              </router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'notices' }">
              <router-link :to="{ name: 'notices' }" class="snb_list">{{
                $t('library.sidebar.8706')
              }}</router-link>
              <span></span>
            </li>
          </ul>
        </div>

        <div class="snb_box">
          <p class="snb_tit">{{ $t('library.sidebar.815') }}</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'sitemap' }">
              <router-link :to="{ name: 'sitemap' }" class="snb_list">{{
                $t('library.sidebar.5305')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'terms' }">
              <router-link :to="{ name: 'terms' }" class="snb_list">{{
                $t('library.sidebar.6490')
              }}</router-link>
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'privacy' }">
              <router-link :to="{ name: 'privacy' }" class="snb_list">{{
                $t('library.sidebar.1298')
              }}</router-link>
              <span></span>
            </li>
          </ul>
        </div>
        <div class="snb_box">
          <p class="snb_tit">교강사 전용</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'postPresent' }">
              <router-link :to="{ name: 'postPresent' }" class="snb_list"
                >증정 코드 입력</router-link
              >
              <span></span>
            </li>
            <li :class="{ active: $route.name === 'present' }">
              <router-link :to="{ name: 'present' }" class="snb_list"
                >증정 요청</router-link
              >
              <span></span>
            </li>
          </ul>
        </div>
        <div class="snb_box">
          <p class="snb_tit">일반회원 전용</p>
          <ul class="snb_sub">
            <li :class="{ active: $route.name === 'couponSecond' }">
              <router-link :to="{ name: 'couponSecond' }" class="snb_list"
                >체험판 코드 입력</router-link
              >
              <span></span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ########### SIDEBAR END ################ -->
    <!-- NEW LIST MODAL -->
    <transition name="modal-fade">
      <CreateNewModal v-if="showNewModal" @close="closeNewModal" />
    </transition>
    <!-- // NEW LIST MODAL -->

    <!-- EDIT LIST MODAL -->
    <transition name="modal-fade">
      <EditModal
        v-if="showEditModal"
        :bookshelf="currentEditBookshelf"
        @close="closeEditModal"
      />
    </transition>
    <!-- // EDIT LIST MODAL -->

    <!-- DELETE MODAL -->
    <transition name="modal-fade">
      <DeleteModal
        v-if="showDeleteModal"
        :bookshelf="currentDeleteBookshelf"
        @close="closeDeleteModal"
      />
    </transition>
    <!-- END DELETE MODAL -->
  </div>
</template>

<script>
/**
 * 변수정리
 * BOOKSHELF_GET_LIST -> 책장목록
 * getCurrentBookshelf -> sidebar에서 선택된 서재정보 객체
 * getCurrentBookshelfBooks -> sidebar에서 선택된 서재의 책들 배열
 * getBookshelfTotalBookCount -> sidebar에서 선택된 서재의 책들 갯수
 * getBookshelves-> 현재생성되어있는 서재들모음
 * getBookshelfCount -> 생성된 책장 갯수
 * bookshelfTp -> 빈책장(UBS),구입(DBS),선물(GFT),증정(PRS),체험(CPN)
 * bookshelfNm -> 서재이름
 */
import ListItem from '@/components/library/ListItem.vue'
import CreateNewModal from '@/components/library/CreateNewModal.vue'
import EditModal from '@/components/library/EditModal.vue'
import DeleteModal from '@/components/library/DeleteModal.vue'
import { mapGetters } from 'vuex'
import {
  UI_CLOSE_SIDEBAR,
  BOOKSHELF_MOVE,
  UI_UNSELECT_ALL_BOOKS,
  UI_DISABLE_MOVE_BOOK_MODE
} from '@/store/types'
import draggable from 'vuedraggable'

export default {
  name: 'Sidebar',
  components: {
    ListItem,
    CreateNewModal,
    EditModal,
    DeleteModal,
    draggable
  },
  data() {
    return {
      showNewModal: false,
      showEditModal: false,
      showDeleteModal: false,
      currentEditBookshelf: null,
      currentDeleteBookshelf: null,
      isShelfMoveMode: false,
      draggableBookshelves: [],
      modeInit: false,
      needsScroll: false,
      isInitialPageLoad: true
    }
  },
  computed: {
    ...mapGetters([
      'getBookshelves',
      'isBookshelfLoading',
      'getBookshelfCount',
      'getCurrentUser',
      'isAuthLoading',
      'isShowLineBanner',
      'getCurrentBookshelf',
      'isMoveBookModeEnabled'
    ]),
    //책장 나누기
    staticBookshelves() {
      return this.getBookshelves.filter((e) => e.bookshelfTp === 'DBS')
    },
    // 드래그 가능한 일반 책장 (UBS)
    userBookshelves() {
      return this.getBookshelves.filter(
        (e) =>
          e.bookshelfTp !== 'DBS' &&
          e.bookshelfTp !== 'GFT' &&
          e.bookshelfTp !== 'PRS' &&
          e.bookshelfTp !== 'CPN'
      )
    },
    baseBookshelves() {
      return this.getBookshelves.filter(
        (e) =>
          e.bookshelfTp !== 'GFT' &&
          e.bookshelfTp !== 'PRS' &&
          e.bookshelfTp !== 'CPN'
      )
    }
  },
  watch: {
    // getBookshelves가 변경될 때 draggableBookshelves 초기화
    baseBookshelves: {
      handler() {
        if (!this.isShelfMoveMode) {
          this.draggableBookshelves = [...this.userBookshelves]
        }
      },
      immediate: true
      // deep: true
    },
    isMoveBookModeEnabled(newValue) {
      this.modeInit = newValue
    },
    draggableBookshelves: {
      handler() {
        this.checkScrollForActiveItem()
      },
      deep: true
    },
    isShelfMoveMode() {
      this.checkScrollForActiveItem()
    },
    '$route'() {
      this.$nextTick(this.checkScrollForActiveItem)
    }
  },
  created() {
    if (this.userBookshelves && this.userBookshelves.length > 0) {
      this.draggableBookshelves = [...this.userBookshelves]
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkScrollForActiveItem)
    this.observer()
    this.setupMenuObserver()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScrollForActiveItem)
  },
  methods: {
    closeSidebar() {
      this.$store.commit(UI_CLOSE_SIDEBAR)
    },
    closeEditMenu() {
      this.$emit('closeEditMenu')
    },
    openNewModal() {
      this.showNewModal = true
      this.isShelfMoveMode = false
    },
    closeNewModal() {
      this.showNewModal = false
    },
    openEditModal(bookshelf) {
      this.currentEditBookshelf = bookshelf
      this.showEditModal = true
    },
    closeEditModal() {
      this.currentEditBookshelf = null
      this.showEditModal = false
    },
    openDeleteModal(bookshelf) {
      this.currentDeleteBookshelf = bookshelf
      this.showDeleteModal = true
    },
    closeDeleteModal() {
      this.currentDeleteBookshelf = null
      this.showDeleteModal = false
    },
    onBookshelfChanged() {
      this.$emit('bookshelfChanged')
    },
    moveShelf() {
      this.isShelfMoveMode = !this.isShelfMoveMode
      if (this.isMoveBookModeEnabled == true) {
        this.$store.commit(UI_UNSELECT_ALL_BOOKS)
        this.$store.commit(UI_DISABLE_MOVE_BOOK_MODE)
        if (this.getCurrentUser) {
          this.$emit('default-books')
        }
      }
    },
    fixShelf() {
      this.isShelfMoveMode = false
      this.saveBookshelfOrder()
    },
    async onDragEnd(evt) {
      // 디버깅용 @end="onDragEnd" 선언해서 사용
      console.log('드래그 종료: ', {
        oldIndex: evt.oldIndex,
        newIndex: evt.newIndex
      })
      console.log(
        '새 순서:',
        this.draggableBookshelves.map((shelf) => shelf.name)
      )
    },
    async saveBookshelfOrder() {
      try {
        const reorderData = this.draggableBookshelves.map((shelf, index) => ({
          bookshelfId: shelf.id,
          orders: index + 1
        }))
        await this.$store.dispatch(BOOKSHELF_MOVE, reorderData)
        return true
      } catch (error) {
        // console.error('책장 순서 저장 중 오류 발생:', error)
        this.draggableBookshelves = [...this.baseBookshelves]
        return false
      }
    },
    observer() {
      const scrollBox = this.$el.querySelector('.snb_box.user_name + .snb_box')
      if (scrollBox) {
        const observer = new MutationObserver(() => {
          this.checkScrollForActiveItem()
        })
        observer.observe(scrollBox, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        })
        this._scrollObserver = observer
      }
    },
    checkScrollForActiveItem() {
      this.$nextTick(() => {
        const scrollBox = this.$el.querySelector(
          '.snb_box.user_name + .snb_box'
        )
        if (!scrollBox) return
        const hasActiveItem =
          scrollBox.querySelector('.select_item.active') !== null
        if (!hasActiveItem) {
          scrollBox.style.overflowY = 'auto'
          return
        }
        const isScrollNeeded = scrollBox.scrollHeight > scrollBox.clientHeight
        scrollBox.style.overflowY = isScrollNeeded ? 'auto' : 'visible'
      })
    },
    setupMenuObserver() {
      const scrollBox = this.$el.querySelector('.snb_box.user_name + .snb_box')
      if (!scrollBox) return
      let prevScrollHeight = scrollBox.scrollHeight
      const menuObserver = new MutationObserver(() => {
        setTimeout(() => {
          const currentScrollHeight = scrollBox.scrollHeight
          if (
            !this.isInitialPageLoad &&
            currentScrollHeight > prevScrollHeight
          ) {
            setTimeout(() => {
              scrollBox.scrollTo({
                top: currentScrollHeight,
                behavior: 'smooth'
              })
            }, 100)
          }
          prevScrollHeight = currentScrollHeight
        }, 100)
      })
      menuObserver.observe(scrollBox, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      })
      this._menuObserver = menuObserver
      setTimeout(() => {
        this.isInitialPageLoad = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.aside_snb {
  min-width: 240px;
  padding-top: 0;
  .snb_box.user_name {
    & + .snb_box {
      padding: 0 0 24px 0;
    }
  }
}
.aside_snb .snb_box.user_name + .snb_box {
  max-height: 810px;
  overflow-y: auto;
}
// .aside_snb .snb_box.user_name + .snb_box:has(.select_item.active) {
//   overflow-y: visible;
// }
.aside_snb .snb_box.user_name + .snb_box.editing-mode {
  overflow-y: visible;
}
.test {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: none;
}
.ghost-bookshelf {
  /* 하드웨어 가속 활성화 */
  transform: translate3d(0, 0, 0);
  will-change: transform;

  /* 터치 선택 효과 비활성화 */
  -webkit-tap-highlight-color: transparent;

  /* 불필요한 스타일 최소화 */
  box-shadow: none !important;
  opacity: 0.8;
  background: #f5f5f5;

  /* 애니메이션 최소화 */
  transition: none !important;
}
.user_name {
  position: relative;
  // top: -54px;
  padding: 24px 15px 24px 24px;
  span.base_NM18 {
    flex: 0.9;
    word-break: break-word;
    line-height: 27px;
    font-size: 27px;
    color: #3ab7ab;
    // border-bottom: 5px solid #36c2b5;
  }
}
.book_sort {
  display: flex;
  justify-content: space-between;
  align-items: center;
  i {
    width: 23px;
    height: 23px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.snb_menu_area {
  .user_name {
    top: 10px;
  }
}
.snb_list {
  text-align: left;
}
.snb_list span b {
  font-size: 5px;
  vertical-align: top;
  margin-right: 8px;
}
.aside_snb .snb_insert {
  position: relative;
  margin-top: 55px;
  padding: 12px 21px 0px 21px;
}
.aside_snb .btn_insert {
  position: relative;
  display: block;
  padding: 7px 16px;
  width: 198px;
  height: 40px;
  text-align: left;
  border: 1px dashed rgba(119, 136, 153, 0.5);
  border-radius: 3px;
}
.aside_snb .btn_insert span {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: #778899;
}
.aside_snb .btn_insert .svg_insert {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 40px;
  height: 40px;
  background: url('../../assets/images/icon_insert.png') center 13px no-repeat;
  text-indent: -9999px;
}
.info_ment {
  position: absolute;
  top: -20px;
  left: 20px;
  padding: 5px 10px;
  background: #000000cc;
  border-radius: 9px;
  letter-spacing: 0.1px;
  font-size: 11px;
  color: #fff;
  &::after {
    content: '';
    position: absolute;
    bottom: -6px; /* 삼각형 위치 조정 */
    left: 15px; /* 삼각형 좌우 위치 조정 */
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #000000cc; /* 삼각형 색상, 배경색과 동일하게 설정 */
  }
}
.fix_shelf {
  padding: 4px 14px;
  border-radius: 14px;
  border: 1px solid #ddd;
  font-size: 12px;
  user-select: none;
  cursor: pointer;
  color: #000;
}

@media (max-width: 1620px) {
  .aside_snb .snb_box .snb_tit2 {
    padding-left: 5px;
  }
}
</style>
